// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f_h","item":"f_j","icon":"f_k","label":"f_l"};